import React from "react";
import { Link } from "react-router-dom";
import { Shield, Clock, MapPin } from "lucide-react";

const villes = ["Saint-Denis", "Saint-Pierre", "Le Tampon", "Saint-Paul", "Saint-Louis", "Saint-André", "Le Port", "Saint-Benoît"];
const services = ["Retour affectif Réunion", "Retour de l'être aimé", "Désenvoûtement 974", "Protection spirituelle", "Voyance Réunion", "Maraboutage d'amour"];
const slug = (v) => "/marabout-" + v.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/ /g, "-");

const Footer = () => (
  <footer className="bg-zinc-950 border-t border-amber-500/15" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10">
        <div>
          <p className="font-heading text-xl gold-text mb-2">Marabout Réunion</p>
          <p className="text-xs tracking-[0.25em] uppercase text-zinc-500 mb-4">Maître Diamma · 974</p>
          <p className="text-zinc-400 text-sm leading-relaxed">Marabout voyant médium africain à La Réunion, spécialiste du retour affectif dans tout le 974.</p>
        </div>
        <div>
          <h4 className="font-heading text-sm text-amber-200 mb-4 tracking-wider">Services</h4>
          <ul className="space-y-2 text-zinc-400 text-sm">{services.map((s) => <li key={s}>{s}</li>)}</ul>
        </div>
        <div>
          <h4 className="font-heading text-sm text-amber-200 mb-4 tracking-wider">Villes</h4>
          <ul className="space-y-2 text-sm">
            {villes.map((v) => (
              <li key={v}><Link to={slug(v)} className="text-zinc-400 hover:text-amber-300 transition-colors duration-300">Marabout {v}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-heading text-sm text-amber-200 mb-4 tracking-wider">Informations</h4>
          <div className="space-y-3 text-zinc-400 text-sm">
            <p className="flex items-center"><Clock className="w-4 h-4 text-amber-400 mr-2" />7j/7 · 7h00 – 23h30 (heure de La Réunion)</p>
            <p className="flex items-center"><MapPin className="w-4 h-4 text-amber-400 mr-2" />La Réunion (974)</p>
            <p className="flex items-center"><Shield className="w-4 h-4 text-amber-400 mr-2" />Discrétion assurée</p>
          </div>
        </div>
      </div>
      <div className="gold-divider my-10" />
      <p className="text-center text-zinc-500 text-xs leading-relaxed mb-4">
        Marabout Réunion 974 · Voyant Saint-Denis · Médium Saint-Pierre · Marabout Le Tampon · Retour affectif · Désenvoûtement Réunion · Marabout africain
      </p>
      <p className="text-center text-zinc-600 text-xs">© 2026 Marabout Réunion 974 – Maître Diamma. Tous droits réservés.</p>
    </div>
  </footer>
);

export default Footer;
